<template>
  <b-container>
    <b-row>
      <h2>{{ $t("checklist.form.typing") }}</h2>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <br />
    <!-- <div>{{ tableFilters.values }}</div> -->

    <base-detailed-filter :fields.sync="tableFilters.values" :formName.sync="tableFilters.formName">
    </base-detailed-filter>
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >

        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <div v-if="tableFilters[field.key] != null">
                <b-form-input
                  type="date"
                  v-if="field.key == 'dateScheduler'"
                  v-model="tableFilters[field.key]"
                />
                <b-form-input
                  v-else
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <b-col class="buttons">
            <div v-if="canShowFillButton(data.item)">
              <router-link :to="getUrlFill(data.item)">
                <b-button size="sm">
                  {{ $t("checklist.sidebar.Fill") }}
                </b-button>
              </router-link>
              <b-button
                class="ml-2"
                size="sm"
                @click="deleteDraft(data.item.checklistId)"
              >
                {{ $t("checklist.form.deleteDraft") }}
              </b-button>
            </div>
            <router-link v-else :to="getUrlDetails(data.item)">
              <b-button size="sm">{{ $t("geral.detalhes") }}</b-button>
            </router-link>
          </b-col>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>
      <b-col>
        <label for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}</label
        >
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-select
              v-model="tablePerPage"
              id="perPageSelect"
              size="sim"
              :options="tablePageOptions"
            />
          </b-col>
          <b-col>
            <label for="perPageSelect">Registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import BaseDetailedFilter from "@/components_rms/base/BaseDetailedFilter.vue";

export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    BaseDetailedFilter,
  },
  data: function () {
    return {
      alert: {
        success: "",
        error: "",
      },
      apiFilter: {
        currentPage: 1,
        perPage: 10,
        checklistId: null,
        formName: null,
        formSearchKey: null,
        fillDateBegin: null,
        fillDateEnd: null,
        fillUserName: null,
        values: [],
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "checklist-filled-table-col-buttons",
        },
        {
          key: "checklistId",
          sortable: false,
          label: "Checklist",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "description",
          sortable: false,
          label: "Descrição",
        },
        {
          key: "formSearchKey",
          sortable: true,
          label: "Chave de busca",
        },
        {
          key: "formName",
          sortable: true,
          label: "Formulário",
        },
        {
          key: "dateScheduler",
          sortable: true,
          label: "Data agendamento",
          formatter: (value, key, item) => {
            let date = new Date(item.dateScheduler);
            return date.toLocaleDateString();
          },
        },
        {
          key: "delayedDays",
          sortable: true,
          label: "Dias em atraso",
        },
        {
          key: "userFillName",
          sortable: true,
          label: "Responsável preenchimento",
        },
      ],
      tableFilters: {
        checklistId: "",
        dateScheduler: "",
        delayedDays: "",
        description: "",
        formName: "",
        formSearchKey: "",
        userFillName: "",
        values: [],
      },
      filterFields: [],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    filterFieldApplied(filter) {
      this.filterFields = Array.from(filter);
      this.tableFilters.values = this.filterFields;
    },
    canShowFillButton(checklist) {
      if (checklist) {
        if (checklist.canCurrentUserFill) {
          return true;
        }
      }
      return false;
    },
    deleteDraft(id) {
      this.$apiChecklist
        .get("/checklist/delete/" + id.toString())
        .then((response) => {
          console.log(response.data);
          console.log(response.data.title);
          this.alert.success = response.data.title;
          this.$refs.table.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    getUrlDetails(checklist) {
      return `/checklist/form/filled/details/${checklist.checklistId}`;
    },
    getUrlFill(checklist) {
      return `/checklist/Layout/form/Fill/${checklist.formId}/${checklist.checklistId}`;
    },
    myProvider(ctx, callback) {
      this.isBusy = true;
      ctx.filter.formName = this.tableFilters.formName;      
      this.apiFilter = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        checklistId: ctx.filter.checklistId,
        dateSchedulerBegin: ctx.filter.dateScheduler,
        dateSchedulerEnd: ctx.filter.dateScheduler,
        delayedDays: ctx.filter.delayedDays,
        description: ctx.filter.description,
        fillUserName: ctx.filter.userFillName,
        formName: ctx.filter.formName,
        formSearchKey: ctx.filter.formSearchKey,
        values: ctx.filter.values,
      };
      this.$apiChecklist
        .post("/checklist/typing/", this.apiFilter)
        .then((response) => {
          console.log(response.data.items);
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    exportCsv() {
      this.$apiChecklist
        .request({
          url: "/checklist/exporttocsv/",
          method: "POST",
          data: this.apiFilter,
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
  },
  watch: {
    tableFilters(){
      this.myProvider()
    }
  },
};
</script>

<style>
.checklist-filled-table-col-buttons {
  width: 130px;
}
</style>
